import { bestGuessRegion } from "./localisation-service";
import { getConfig, TEnvironmentKey, TProductKey } from "../config/config";

const ensureProduct = (): TProductKey => {
  // when whitelabeling we need to add logic here for URLs
  return "Smokeball";
};

const ensureEnvironment = (): TEnvironmentKey => {
  // when whitelabeling we need to add logic here for URLs
  const host = window.location.host.toLowerCase();

  if (host.startsWith("dev") || host.startsWith("localhost")) {
    return "Dev";
  }
  if (host.startsWith("staging")) {
    return "Staging";
  }

  return "Production";
};

export const ensureConfig = () => {
  const product = ensureProduct();
  const environment = ensureEnvironment();
  const region = bestGuessRegion();

  const config = {
    ...getConfig(product, environment, region.code),
    product,
    environment,
    region,
  };
  // console.log("derived config: ", config);
  return config;
};
